import meny_routes from './meny_routes';
import meny_light_routes from './meny_light_routes';

let routes = [];

meny_routes.forEach((route) => routes.push(route));
meny_light_routes.forEach((route) => routes.push(route));

export default routes;
